import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Breadcrumbs from '../components/Breadcrumbs';
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';

const API = process.env.REACT_APP_BACKEND_URL;

const fmt = (p) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(p);

export default function AccessoriesPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/products`)
      .then((r) => r.json())
      .then((all) => setItems(all.filter((p) => p.group === 'accessories')))
      .catch(() => {});
  }, []);

  return (
    <>
      <Helmet>
        <title>Genuine Accessories & Spare Parts for Harpalyk Robots | Harpalyk India</title>
        <meta name="description" content="Buy genuine Harpalyk accessories and spare parts — Li-Ion batteries, consumables and replacement parts for SMARTBOT, SHINEBOT, POOLBOT and LAWNBOT robots. Pan-India delivery." />
        <link rel="canonical" href="https://harpalyk.com/accessories" />
      </Helmet>
      <Header />
      <main className="pt-20" data-testid="accessories-page">
        <div className="h-1 bg-gradient-to-r from-gray-700 via-gray-400 to-transparent" aria-hidden="true" />
        <Breadcrumbs items={[{ label: 'Accessories' }]} />
        <section className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-16 px-6 lg:px-12">
          <div className="max-w-6xl mx-auto">
            <p className="font-heading text-sm font-bold tracking-[0.3em] text-white/50 uppercase mb-3">Harpalyk</p>
            <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-4">Genuine Accessories & Spare Parts</h1>
            <p className="text-lg text-gray-300 max-w-2xl">
              Keep your Harpalyk robot performing like new — genuine batteries, consumables and replacement parts with pan-India delivery.
            </p>
          </div>
        </section>
        <section className="py-16 px-6 lg:px-12 bg-gray-50">
          <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="accessories-grid">
            {items.map((p) => (
              <a
                key={p.slug}
                href={`/products/${p.slug}`}
                data-testid={`accessory-card-${p.slug}`}
                className="group bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow overflow-hidden"
              >
                <div className="h-52 bg-white flex items-center justify-center overflow-hidden">
                  <img src={p.image} alt={`Harpalyk genuine accessory — ${p.name}`} className="h-full w-full object-contain p-4 group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <p className="text-[11px] font-semibold tracking-[0.18em] text-gray-400 uppercase mb-1">HARPALYK · GENUINE PART</p>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{p.name}</h3>
                  <p className="flex items-baseline gap-2">
                    {p.onSale && p.originalPrice !== p.salePrice && (
                      <span className="text-sm text-gray-400 line-through">{fmt(p.originalPrice)}</span>
                    )}
                    <span className="text-xl font-bold text-gray-900">{fmt(p.salePrice || p.originalPrice)}</span>
                  </p>
                  <span className="inline-block mt-4 text-sm font-semibold text-emerald-600 group-hover:text-emerald-700">View Details →</span>
                </div>
              </a>
            ))}
            {items.length === 0 && <p className="text-gray-400" data-testid="accessories-loading">Loading accessories…</p>}
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppWidget />
    </>
  );
}
